import { Pie, LoadingSpinner, Warning, SvgBackground } from "@components";
import {
    AppState,
    TotalMetricInfo,
    reportClicksAndImpressions,
    selectCampaignById,
    CampaignInfo,
    campaignSpentBudgetSelector
} from "@store";
import * as React from "react";
import { connect } from "react-redux";
import "./ReportsAsideComponent.css";
import { ReportsParametersForm } from "./ReportsParametersForm";
import { ReportUrl, formatNumber, CampaignSpentBudget } from "@common";
import { FetchingState } from "rd-redux-http";
import { Warning_red_bg } from "@icons";

export interface ReportsAsideProps {
    totals: TotalMetricInfo[];
    activeCampaign?: CampaignInfo;
    spentBudget: CampaignSpentBudget & { isLoading: boolean };
    loading: boolean;
    loadingFailed: boolean;
    hasData: boolean;
}

function ReportsAsideComponent({
    totals,
    activeCampaign,
    spentBudget,
    hasData,
    loading,
    loadingFailed
}: ReportsAsideProps) {
    return (
        <>
            {hasData ? (
                <>
                    <ReportsParametersForm />
                    <section className="filters-result">
                        <ul className="filters-result-list">
                            {loadingFailed ? (
                                <li className="filters-result-list-item ">
                                    <SvgBackground className="report-aside-bad-svg" svg={Warning_red_bg} />
                                    <Warning
                                        className="warning_red"
                                        title="Warning"
                                        text="Data is temporarily not available. Please refresh the page"
                                    />
                                    <span>-</span>
                                </li>
                            ) : loading ? (
                                <li className="filters-result-list-item">
                                    <span className="loading-label">
                                        <LoadingSpinner className="centered-loading" />
                                    </span>
                                </li>
                            ) : (
                                <>
                                    {totals.map(({ name, value }: TotalMetricInfo, index: number) => {
                                        return (
                                            <li
                                                className="filters-result-list-item"
                                                /*className="bordered-block"*/ key={`result-${index}`}
                                            >
                                                <p className="result-title">{name}</p>
                                                <p className="result-value">{formatNumber(value)}</p>
                                            </li>
                                        );
                                    })}
                                </>
                            )}
                            {loadingFailed ? (
                                <li className="pie-diargram-block filters-result-list-item">
                                    <p className="result-title">Total Spent</p>
                                    <p className="result-value custom-filters-result-value">
                                        <SvgBackground className="report-aside-bad-svg" svg={Warning_red_bg} />
                                        <Warning
                                            className="warning_red"
                                            title="Warning"
                                            text="Data is temporarily not available. Please refresh the page"
                                        />
                                        <span>-</span>
                                    </p>
                                </li>
                            ) : spentBudget.isLoading ? (
                                <li className="pie-diargram-block filters-result-list-item ">
                                    <span className="loading-label">
                                        <LoadingSpinner className="centered-loading" />
                                    </span>
                                </li>
                            ) : (
                                <li className="pie-diargram-block filters-result-list-item ">
                                    <p className="result-title">Total Spent</p>
                                    <div className="spent-graph">
                                        <div className="graph-title-wrap">
                                            <span className="graph-title">
                                                {`${((1 - spentBudget.spentPart) * 100).toFixed(0)}%`}
                                            </span>
                                            <span className="graph-subtitle">Open</span>
                                        </div>
                                        <Pie
                                            data={[
                                                { value: spentBudget.spentPart, color: "rgb(26,127,179)" },
                                                { value: 1 - spentBudget.spentPart, color: "rgba(26,127,179 , 0.2)" }
                                            ]}
                                            circleWidth={12}
                                            className={"graph-donut"}
                                        />
                                        <div className="graph-title-wrap graph-bottom-title">
                                            <span className="graph-title ">{`${(spentBudget.spentPart * 100).toFixed(
                                                0
                                            )}%`}</span>
                                            <span className="graph-subtitle">Spent</span>
                                        </div>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </section>
                </>
            ) : (
                <section className="filters-result">
                    <span style={{ display: "inline-block", width: "100%", textAlign: "center", fontSize: ".625rem" }}>
                        Data is temporarily not available.<br />Please refresh the page
                    </span>
                </section>
            )}
        </>
    );
}

export const ReportsAside = connect(
    (appState: AppState): Partial<ReportsAsideProps> => {
        const urlState = ReportUrl.match(window.location.toString(), true);
        const { campaignId } = urlState.isMatched ? urlState.params : { campaignId: undefined };
        return {
            hasData:
                FetchingState.isInitialOrFetching(appState.campaignList.campaigns) ||
                FetchingState.getDataOrDefault(appState.campaignList.campaigns, []).length > 0,
            loading:
                FetchingState.isInitialOrFetching(appState.campaignList.campaigns) ||
                FetchingState.isInitialOrFetching(appState.reports.chartData.overallData),
            loadingFailed:
                FetchingState.isError(appState.campaignList.campaigns) ||
                FetchingState.isError(appState.reports.chartData.overallData),
            totals: reportClicksAndImpressions(appState),
            spentBudget: campaignSpentBudgetSelector(appState, campaignId || ""),
            ...(campaignId ? { activeCampaign: selectCampaignById(appState, campaignId) } : {})
        };
    }
)(ReportsAsideComponent);
